module.exports = [
  {
    position: 'DA',
    specialty: 'General',
    display: 'Dental Assistant',
    url: 'dental-assistant',
    occupation: '31-9091',
    description:
      'The dental assistant is a healthcare professional whose primary job responsibility is to provide chair-side assistance to the dentist. In addition, you may be called upon to deliver a wide range of services depending on the size of the dental practice and the needs of the dentist.',
  },
  {
    position: 'DH',
    specialty: 'General',
    display: 'Dental Hygienist',
    url: 'dental-hygienist',
    occupation: '29-1292',
    description:
      'The dental hygienist plays a vital role in providing patient care by working with the dentist to identify and treat oral diseases. In this position, the dental hygienist completes oral health exams, performs oral prophylaxis, and periodontal therapy. The dental hygienist also maintains the patient’s medical history, educates the patient on proper preventative care and overall oral health and wellness.',
  },
  {
    position: 'DD',
    specialty: 'General',
    display: 'Dentist',
    url: 'dentist',
    occupation: '29-1021',
    description:
      'A general Dentist provides general dental care and services to patients. A general Dentist may refer patients to specialists in certain situations but is equipped to handle the full range of basic dental care.',
  },
  {
    position: 'FO',
    specialty: 'Office Manager',
    display: 'Dental Office Manager',
    specialty_url: 'dental-office-manager',
    url: 'dental-front-office',
    occupation: '43-1011',
    description:
      'A dental office manager supervises the entire dental front office team, motivating them and keeping them on track and focused. This is a job that comes with a great deal of responsibility, so a manager should always be prepared for anything.',
  },
  {
    position: 'FO',
    specialty: 'Reception',
    display: 'Dental Receptionist',
    specialty_url: 'dental-receptionist',
    url: 'dental-front-office',
    occupation: '43-4171',
    description:
      'The front desk dental receptionist handles various tasks around the dental office that help make the work of a dentist easier. For example, they take many phone calls during the day, schedule appointments, and keep charts up to date.',
  },
];
